import { LocationTypeInfo } from './location_type_info.js';

class LocationTaxonomy {
  get({ type, subtype = '' }) {
    return new LocationTypeInfo({ type, subtype });
  }

  // Represents a tree of categories (types) and their subtypes.
  get hierarchy() {
    if (!this.#hierarchy) {
      this.#hierarchy = Array.from(Object.entries(LocationTypeInfo.Data))
        .filter(([category]) => category != 'poi')
        .map(([category, info]) => {
          let subtypes = info.subtypes;
          if (!(info.subtypes instanceof Array)) {
            subtypes = Array.from(Object.values(subtypes)).map(t => t.name);
          }
          return {
            category,
            categoryName: info.name,
            subtypes,
          };
        });
    }
    return this.#hierarchy;
  }

  // Returns a pair of [type, subtype] the given name matches.
  typeByName(name) {
    let lastWord = name.match(/\s(\w+)$/);
    if (!lastWord) {
      return null;
    }
    let term = lastWord[1].toLowerCase();
    for (let typeItem of this.hierarchy) {
      if (
        typeItem.subtypes.length == 0 &&
        typeItem.categoryName.toLowerCase() == term
      ) {
        return [typeItem.category, typeItem.categoryName];
      }
      let subtype = typeItem.subtypes.find(subtype => {
        let words = subtype.toLowerCase().split(' ');
        let lastWord = words[words.length - 1];
        return lastWord == term;
      });
      if (subtype) {
        return [typeItem.category, subtype];
      }
    }
    return null;
  }

  #hierarchy;
}

export const locationTaxonomy = new LocationTaxonomy();
